<template>
  <!-- 社会心智课 -->
  <div class="shehuixinzhike">
    <PublicCert :logo="Logo8" :type="'jy-sm'" :color="'#472784'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo8 from '@/assets/images/logo8.png'

export default {
  name: 'SheHuiXinZhi',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo8
    }
  }
}
</script>
